import userData from "./user.reducer";

import { combineReducers } from "redux";

const rootReducer = combineReducers({
    userData
})

export default rootReducer;